import React, { useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
// icons/images imports
import { useNavigate } from 'react-router-dom';
import { forgotPass } from '../../api/paths';
import api from '../../api/base';
import { CommonPagesWrapper, CustomBasicInput, LoginButton, LoginFormWrapper, TextWrapper } from '../Login/Login.styles';
import { BackLoginText } from '../../components/VerifyOtp/VerifyOtp.styles';
import { ReactComponent as ArrowLeft } from '../../assets/icons/base/arrow-left.svg';
import useError from '../../hooks/useError';
import { MainTheme } from '../../theme';
import LoginContainer from '../Login/LoginContainer';

const ForgotPassword = () => {
  const [email, setEmail] = useState<string>('');
  const [sent, setSent] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  const [handleError] = useError();

  const handleSendRequestPassword = async (e: any) => {
    e.preventDefault();

    setLoading(true);
    try {
      await api.post(forgotPass, { email });
      setSent(true);
    } catch (error: any) {
      handleError(error);
    }
    setLoading(false);
  };

  return (
    <MainTheme forceTheme={'dark'}>
      <CommonPagesWrapper>
        <LoginContainer>
          <LoginFormWrapper onSubmit={handleSendRequestPassword}>
            {sent
              ? (
                <Box display={'flex'} flexDirection={'column'} gap={'32px'}>
                  <TextWrapper gap="8px">
                    <Typography variant="dsm" color={(t) => t.palette.base.bodyText} fontWeight="600">
                        Check your email
                    </Typography>
                    <Box>
                      <Typography component="span" variant="tmd" color={(t) => t.palette.grey[500]}>
                        We sent a password reset link to {' '}
                      </Typography>
                      <Typography component="span" variant="tmd" color={(t) => t.palette.primary.main}>
                        {email}
                      </Typography>
                    </Box>
                  </TextWrapper>
                  <Grid width={'100%'} item xs={12}>
                    <LoginButton
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={() => navigate('/')}
                      size="large"
                    >
                      Back to login
                    </LoginButton>
                  </Grid>
                  <Box>
                    <Typography component="span" variant="tsm" color={(t) => t.palette.grey[500]}>
                      Didn’t receive the email? {' '}
                    </Typography>
                    <Typography
                      component="span"
                      variant="tsm"
                      color={(t) => t.palette.primary.main}
                      fontWeight="500"
                    >
                      Click to resend
                    </Typography>
                  </Box>
                </Box>
              )
              : (
                <>
                  <TextWrapper gap="8px">
                    <Typography variant="dsm" color="#F9FAFB" fontWeight="600">
                        Forgot password?
                    </Typography>
                    <Typography variant="tmd" color="#98A2B3">
                        No worries, we’ll send you reset instructions.
                    </Typography>
                  </TextWrapper>
                  <Grid width={'100%'} item marginTop={'32px'}>
                    <CustomBasicInput
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder='Enter your email'
                    />
                  </Grid>
                  <Grid width={'100%'}
                    item
                    xs={12}
                    marginTop={'24px'}>
                    <LoginButton
                      variant="contained"
                      color="primary"
                      fullWidth
                      type="submit"
                      loading={loading}
                      size="large"
                    >
                      Send me password reset link
                    </LoginButton>
                  </Grid>
                  <Grid
                    width={'100%'}
                    item
                    xs={12}
                    marginTop={'32px'}
                  >
                    <BackLoginText
                      onClick={() => navigate('/')}
                      variant="tsm"
                      fontWeight="500"
                    >
                      <ArrowLeft />
                        Back to login
                    </BackLoginText>
                  </Grid>
                </>
              )}
          </LoginFormWrapper>
        </LoginContainer>
      </CommonPagesWrapper>
    </MainTheme>
  );
};

export default ForgotPassword;
